<template>
  <v-dialog v-model="isOpen" max-width="500px">
    <v-card>
      <v-card-title>Remove {{ item }}</v-card-title>
      <v-card-text>
        <p>Are you sure you want to remove this {{ item.toLowerCase() }}?</p>
        <p v-if="description">
          <strong>{{ description }} </strong>
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn color="secondary" @click="canceled">Cancel</v-btn>
        <v-btn color="error" @click="confirmed">Remove</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
interface Props {
  description: string;
  item: string;
  isOpen: boolean;
}
const props = defineProps<Props>();

const description = toRef(props, 'description', '');
const item = toRef(props, 'item', '');
const isOpen = toRef(props, 'isOpen', false);

const emit = defineEmits(['actionCanceled', 'actionConfirmed']);

const canceled = async () => {
  emit('actionCanceled');
};
const confirmed = async () => {
  emit('actionConfirmed');
};
</script>
